import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

export interface DisclosureStep {
  toolCallId: string;
  name: string;
  status: 'running' | 'done' | 'error';
}

@Component({
  selector: 'tellent-assistant-steps-disclosure',
  imports: [ButtonComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './steps-disclosure.component.html',
  styleUrl: './steps-disclosure.component.less',
})
export class TellentAssistantStepsDisclosureComponent {
  protected readonly expanded = signal(false);
  protected readonly count = computed(() => this.steps().length);

  public readonly steps = input.required<readonly DisclosureStep[]>();

  protected toggle(): void {
    this.expanded.update(v => !v);
  }
}
